import React from 'react';

import { TextInput } from '@components/NextForms/TextInput';
import { MobxZodTypes, MobxZodField } from '@monoid-dev/mobx-zod-form';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { getFieldLabel } from '@utils/nextForms';

const useStyles = makeMuiStyles((theme, common) => ({
  gridFormContainer: {
    display: 'grid',
    columnGap: '0.5rem',
    rowGap: '0.5rem',
    gridAutoFlow: 'row',
    '& > label': {
      ...common.middleText,
      ...common.textGray700,
      paddingTop: 5,
    },
  },
  gridFormButtons: {
    ...common.flexInline,
    columnGap: '1.5rem',
  },
}));

export interface GridFormProps {
  fields: MobxZodField<MobxZodTypes>[];
  columns?: number;
  buttons?: React.ReactNode;
}

export const GridForm = ({ fields, columns = 4, buttons }: GridFormProps) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const buttonsFirst = fields.length % columns === 0;

  const groupSize = 2;

  return (
    <div
      className={classes.gridFormContainer}
      style={{ gridTemplateColumns: `repeat(${columns}, max-content 200px)` }}
    >
      {fields.map((field, i) => (
        <React.Fragment key={field.uniqueId}>
          <label
            style={{
              marginLeft: i % columns !== 0 ? '2rem' : undefined,
            }}
            // For each label not at the beginning of a row, make space on the left
          >
            {getFieldLabel(field)}
          </label>
          <div style={{ width: 180 }}>
            <TextInput field={field} />
          </div>
        </React.Fragment>
      ))}

      <div
        className={classes.gridFormButtons}
        style={{
          gridColumnStart: groupSize * (fields.length % columns) + 1,
          gridColumnEnd: -1,
          marginLeft: buttonsFirst ? 0 : '1rem',
        }}
      >
        {buttons}
      </div>
    </div>
  );
};
